"use client";

import React from "react";
import Intro from "@/ui/Intro";

const boysHostel = [
  {
    roomType: "Single Occupancy",
    rooms: 4,
    occupancy: 1,
    beds: 4,
    vacancy: 4,
    price: 12000,
  },
  {
    roomType: "Double Sharing Occupancy",
    rooms: 10,
    occupancy: 2,
    beds: 20,
    vacancy: 19,
    price: 10000,
  },
];

const girlsHostel = [
  {
    roomType: "Single Occupancy",
    rooms: 1,
    occupancy: 1,
    beds: 1,
    vacancy: 0,
    price: 12000,
  },
  {
    roomType: "Triple Sharing Occupancy",
    rooms: 2,
    occupancy: 3,
    beds: 6,
    vacancy: 4,
    price: 10000,
  },
  {
    roomType: "Four Sharing Occupancy",
    rooms: 2,
    occupancy: 4,
    beds: 8,
    vacancy: 8,
    price: 10000,
  },
];

const bermiokFees = [
  {
    category: "Double Sharing",
    semester: "Rs. 45,000/-",
    annual: "Rs. 90,000/-",
  },
];

const HostelTable = ({ title, data }) => (
  <div className="mb-10">
    <h3
      className="text-xl font-semibold text-gray-800 mb-4"
      style={{ fontFamily: "saans-bold" }}
    >
      {title}
    </h3>

    <div className="overflow-x-auto">
      <table className="min-w-full border border-gray-300">
        <thead className="bg-[#00304b] text-white">
          <tr>
            <th className="px-4 py-3 text-left">Room Category</th>
            <th className="px-4 py-3 text-center">Semester Fee (Per Student)</th>
            <th className="px-4 py-3 text-center">Annual Fee (Per Student)</th>
          </tr>
        </thead>

        <tbody>
          {data.map((item, index) => (
            <tr
              key={index}
              className="border-t border-gray-200 hover:bg-gray-50"
            >
              <td className="px-4 py-3 text-left">{item.roomType}</td>
              <td className="px-4 py-3 text-center">Rs. {item.price*6}/-</td>
              <td className="px-4 py-3 text-center">Rs. {item.price*12}/-</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

const Hostelfee = () => {
  return (
    <section className="w-full bg-white">
      <Intro
        title="Hostel Fee Breakdown"
        description="Comprehensive information on hostel accommodation fees, including room charges, amenities and associated services."
      />

      {/* Singtam Campus */}
      <div className="mb-12">
        <h2
          className="text-2xl font-bold text-[#00304b] mb-6"
          style={{ fontFamily: "saans-bold" }}
        >
          SINGTAM CAMPUS
        </h2>

        <HostelTable
          title="Boys Hostel"
          data={boysHostel}
          totalRooms={14}
          totalBeds={24}
          totalVacancy={23}
        />

        <HostelTable
          title="Girls Hostel"
          data={girlsHostel}
          totalRooms={5}
          totalBeds={15}
          totalVacancy={12}
        />
      </div>

      {/* Bermiok Campus */}
      <div>
        <h2
          className="text-2xl font-bold text-[#00304b] mb-6"
          style={{ fontFamily: "saans-bold" }}
        >
          BERMIOK CAMPUS
        </h2>

        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300">
            <thead className="bg-[#00304b] text-white">
              <tr>
                <th className="px-4 py-3 text-left">Room Category</th>
                <th className="px-4 py-3 text-center">
                  Semester Fee (Per Student)
                </th>
                <th className="px-4 py-3 text-center">
                  Annual Fee (Per Student)
                </th>
              </tr>
            </thead>

            <tbody>
              {bermiokFees.map((fee, index) => (
                <tr
                  key={index}
                  className="border-t border-gray-200 hover:bg-gray-50"
                >
                  <td className="px-4 py-3">{fee.category}</td>
                  <td className="px-4 py-3 text-center">{fee.semester}</td>
                  <td className="px-4 py-3 text-center">{fee.annual}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Hostelfee;